module.exports = __webpack_public_path__ + "img/accounting-web-software-awards-2021--top-product--data-and-expense-management.01431ef5.webp";